import React from 'react';
import { RootState } from '../redux/store';
import { changePageFilter } from '../redux/actions/PageActions';
import { connect } from 'react-redux';
import { ConnectedProps } from 'react-redux/es/exports';
import { FormicaProps, withFormica } from '../helpers/withFormica';
import { DataStructure } from '../domain/structure/DataStructureDomains';
import ComponentName from '../constant/ComponentName';
import CollectionNames from '../constant/CollectionNames';
import StructListViewerComponent from '../components/struct/StructListViewerComponent';
import ServiceContainer from '../config/ServiceContainer';
import { ServiceNames } from 'constant/ServiceNames';
import StructService from '../service/StructService';
import { ComponentState, setSelectedItems } from '../redux/actions/ComponentActions';
import StandardContainerComponent, { StandardSubscriptionComponentArgs } from '../helpers/StandardContainerComponent';
import LanguageUtil from '../util/LanguageUtil';
import { BulkActionDependencyError } from 'redux/reducers/BulkActionReducer';

class StructContainer extends StandardContainerComponent<Props, State, DataStructure, {}> {
  private readonly structService: StructService = ServiceContainer.getInstance().get(ServiceNames.STRUCT);

  constructor(props: Props) {
    const args: StandardSubscriptionComponentArgs = {
      component: ComponentName.STRUCT,
      withSchema: false,
      itemCollection: CollectionNames.DATA_STRUCTURES,
      label: LanguageUtil.get({ id: 'pages.struct.title', defaultMessage: 'Structures' }),
    };
    super(props, args);
  }

  protected getListView(): React.ReactNode {
    const { items, itemBuilderView, permissions } = this.state;
    return (
      <StructListViewerComponent
        structures={items}
        openStructure={this.openComponent}
        currentModal={itemBuilderView?.getLastCurrent()}
        views={itemBuilderView?.getListViews()}
        onSortChange={this.onSortChange}
        permissions={permissions}
      />
    );
  }

  protected deployAll(): Promise<BulkActionDependencyError[]> {
    return Promise.resolve([]);
  }

  protected undeployAll(): Promise<BulkActionDependencyError[]> {
    return Promise.resolve([]);
  }

  protected async removeAll(): Promise<BulkActionDependencyError[]> {
    const {
      component: { selectedComponentIds },
    } = this.props;
    await this.structService.removeAll(selectedComponentIds.flatMap((i: DataStructure) => i.name));
    return [];
  }

  protected prepareCount = async () => {
    try {
      const count = await this.structService.getCount(this.getCountFilter().build());
      this.setState({ totalRecord: count });
    } catch (e) {}
  };
}

interface Props extends ReduxProps, FormicaProps {}

class State {}

const mapStateToProps = (state: RootState) => ({
  itemView: state.page.itemView,
  currentCategory: state.page.currentCategory,
  pagePath: state.page.pagePath,
  component: state.component as ComponentState,
  user: state.auth.user,
  attributes: state.auth.attributes,
});

const mapDispatchToProps = { setSelectedItems, changePageFilter };
const connector = connect(mapStateToProps, mapDispatchToProps);
type ReduxProps = ConnectedProps<typeof connector>;

export default withFormica(connector(StructContainer));
